import { slug } from "../Util";

class Section {
  constructor(header, ...body) {
    this.header = header;
    this.slug = slug(header);
    this.body = body;
  }
}

module.exports = {slug, Section};


// WEBPACK FOOTER //
// ./src/cities/Sections.js